import Vue from 'vue'
import App from './App.vue'

import router from './router';
import vuex from 'vuex';

import nav from './components/layouts/nav';
import footer from './components/layouts/footer';
import headerFixed from './components/layouts/header-fixed';
import store from './store/index';
import notification from "./components/layouts/notification";
import loader from "./components/layouts/loader";
import loaderCircle from "./components/layouts/loaderCircle";
import VueScrollTo from 'vue-scrollto'; // ovo izbacit i deinstalirat ovi plugin
import VueAnalytics from 'vue-analytics';

Vue.component('home-nav',nav);
Vue.component('home-footer',footer);
Vue.component('header-fixed',headerFixed);
Vue.component('notify',notification);
Vue.component('loader',loader);
Vue.component('loaderCircle',loaderCircle);

Vue.config.productionTip = false;
Vue.use(vuex);
Vue.use(VueScrollTo); // ovo izbacit
Vue.use(VueAnalytics, {
  id: 'G-WWNPGHGYN1',
  router
});

new Vue({
  render: h => h(App),
  router,store,
}).$mount('#app')
